const firebaseConfig = {
    apiKey: "AIzaSyAGxhGd2qwy0mgFu8UECrMF4cL9CAvrR0U",
    authDomain: "fitness-gym-9f1c9.firebaseapp.com",
    projectId: "fitness-gym-9f1c9",
    storageBucket: "fitness-gym-9f1c9.appspot.com",
    messagingSenderId: "288216176554",
    appId: "1:288216176554:web:31eb38aee0e51bdf08fdd3"
};

export default firebaseConfig;